<template>
    <div>
        <sprint-filter 
            :loading="loading"
            @filter-changed="filterType=$event"
            @refresh="refresh"
        />
        <box>
            <h3 slot="header"><i class="fab fa-jira"></i> {{resource('SprintPlanning_Index_Issues_Header')}}</h3>

            <div slot="body">
                <sprint ref="sprint"
                    :filterType="filterType"
                    @loading="loading = $event"
                />
            </div>
        </box>
    </div>
</template>

<script>

//Components
import BootstrapBox from '../../../Components/Util/BootstrapBox.vue';
import Sprint from './Sprint.vue';
import Filter from './Filter.vue';

//Mixins
import resourceMixin from '../../../Util/Mixins/resources';

export default {
    name: 'sprint-planning-index',
    mixins: [resourceMixin],
    components: {
        'Box': BootstrapBox,
        Sprint,
        'SprintFilter': Filter
    },
    methods: {
        refresh() {
            this.$refs.sprint.refresh();
        }
    },
    data() {
        return {
            filterType: null,
            loading: false
        };
    }
};
</script>

<style lang="scss" scoped>

</style>